import React, { useEffect } from 'react';
import AboutMain from './AboutMain';
import './About.scss';

const About = () => {



  return <AboutMain />;
};

export default About;
